// extracted by mini-css-extract-plugin
export default {"btn":"btn___sJ25g","disabled":"disabled___vDV7C"};